export class SymptomsModel {
    keyword = '';
    domain_id = 0;
}